import React, { reactCSS, Component } from 'react';
import { SwatchesPicker, SketchPicker, ChromePicker } from 'react-color';

class NotificationBoxProperties extends Component {
  constructor(props) {
    super(props);

    this.state = {
      notificationImage: "",
      notificationTitle: "",
      notificationContent: "",
      notificationButtonText: "",
      notificationButtonUrl: "",

      titleDisplayColorPicker: false,
      descriptionDisplayColorPicker: false,
      btnBackgroundDisplayColorPicker: false,
      btnColorDisplayColorPicker: false,
      boxBackgroundDisplayColorPicker: false,

      titleColor: "#000",
      descriptionColor: "#000",
      btnBackgroundColor: "#000",
      btnColorColor: "#FFF",
      boxBackgroundColor: "#FFF"
    }

    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleColorChange = this.handleColorChange.bind(this);
  }

  handleClick = (e) => {
    if ( !e.target.getAttribute('data-picker') ) return

    let propName = e.target.getAttribute('data-picker')+'DisplayColorPicker'
    this.setState({ [propName]: !this.state[propName] })
  }

  handleChange = (e) => {
    this.setState({[e.target.name]: e.target.value}, () => {
      let obj = {
        notificationImage: this.state.notificationImage,
        notificationTitle: this.state.notificationTitle,
        notificationContent: this.state.notificationContent,
        notificationButtonText: this.state.notificationButtonText,
        notificationButtonUrl: this.state.notificationButtonUrl,
        titleColor: this.state.titleColor,
        descriptionColor: this.state.descriptionColor,
        btnBackground: this.state.btnBackgroundColor,
        btnColor: this.state.btnColorColor,
        boxColor: this.state.boxBackgroundColor
      }

      this.props.handleWebviewProps(obj, true);
    });
  }

  handleColorChange = (color, elem) => {
    let propName = elem+'Color';
    this.setState({ [propName]: color.hex }, () => {
      let obj = {
        notificationImage: this.state.notificationImage,
        notificationTitle: this.state.notificationTitle,
        notificationContent: this.state.notificationContent,
        notificationButtonText: this.state.notificationButtonText,
        notificationButtonUrl: this.state.notificationButtonUrl,
        titleColor: this.state.titleColor,
        descriptionColor: this.state.descriptionColor,
        btnBackground: this.state.btnBackgroundColor,
        btnColor: this.state.btnColorColor,
        boxColor: this.state.boxBackgroundColor
      }

      this.props.handleWebviewProps(obj, true);
    })
  }

  handleSubmit = (e) => {
    if ( this.state.notificationTitle.length === 0 || this.state.notificationContent.length === 0 || this.state.notificationButtonText.length === 0 ) return;

    let obj = {
      notificationImage: this.state.notificationImage,
      notificationTitle: this.state.notificationTitle,
      notificationContent: this.state.notificationContent,
      notificationButtonText: this.state.notificationButtonText,
      notificationButtonUrl: this.state.notificationButtonUrl,
      titleColor: this.state.titleColor,
      descriptionColor: this.state.descriptionColor,
      btnBackground: this.state.btnBackgroundColor,
      btnColor: this.state.btnColorColor,
      boxColor: this.state.boxBackgroundColor
    }

    this.props.handleWebviewProps(obj, false);
  }

  render() {
    return(
      <div className="webview-component-group">
        <div className="webview-data-group">
          <p className="group-title">Conteúdo:</p>
          <div className="row">
            <div className="col-12">
              <div className="input-wrapper">
                <label htmlFor="notificationImage" className="no-margin">Qual o link da imagem a aparecer na notificação?</label>
                <input type="url" id="notificationImage" name="notificationImage" className="form-control" onChange={this.handleChange} defaultValue={this.state.notificationImage} />
              </div>
            </div>

            <div className="col-12">
              <div className="input-wrapper">
                <label htmlFor="notificationTitle">Qual será o título da sua notificação? <strong>(Obrigatório)</strong></label>
                <input type="text" id="notificationTitle" name="notificationTitle" className="form-control" onChange={this.handleChange} defaultValue={this.state.notificationTitle} />
              </div>
            </div>

            <div className="col-12">
              <div className="input-wrapper">
                <label htmlFor="notificationContent">Qual será a descrição da sua notificação? <strong>(Obrigatório)</strong></label>
                <textarea name="notificationContent" id="notificationContent" className="form-control" onChange={this.handleChange} defaultValue={this.state.notificationContent}></textarea>
              </div>
            </div>
            
            <div className="col-6">
              <div className="input-wrapper">
                <label htmlFor="notificationButtonText">Qual será o texto do CTA? <strong>(Obrigatório)</strong></label>
                <input type="text" name="notificationButtonText" id="notificationButtonText" className="form-control" onChange={this.handleChange} defaultValue={this.state.notificationButtonText}/>
              </div>
            </div>
            <div className="col-6">
              <div className="input-wrapper">
                <label htmlFor="notificationButtonUrl">Qual será o link do CTA?</label>
                <input type="url" name="notificationButtonUrl" id="notificationButtonUrl" className="form-control" onChange={this.handleChange} defaultValue={this.state.notificationButtonUrl}/>
              </div>
            </div>
          </div>

          <div className="webview-data-group">
            <p className="group-title">Estilo:</p>
            <div className="row">
              <div className="col-4">
                <div className="input-wrapper">
                  <label className="no-margin">Qual a cor de fundo do box?</label>
                  {
                    this.state.boxBackgroundDisplayColorPicker ?
                      <div className="color-picker">
                        <SketchPicker color={ this.state.boxBackgroundColor } onChange={ (color) => { this.handleColorChange(color, 'boxBackground') } } />
                        <div className="selected-color-close" onClick={this.handleClick} data-picker="boxBackground"><i className="linearicons-cross"></i></div>
                      </div>
                    : <div className="selected-color" data-picker="boxBackground" style={{width: "76px", height: "38px", backgroundColor: this.state.boxBackgroundColor}} onClick={this.handleClick}></div>
                  }
                </div>
              </div>

              <div className="col-4">
                <div className="input-wrapper">
                  <label className="no-margin">Qual a cor do título?</label>
                  {
                    this.state.titleDisplayColorPicker ?
                      <div className="color-picker">
                        <SketchPicker color={ this.state.titleColor } onChange={ (color) => { this.handleColorChange(color, 'title') } } />
                        <div className="selected-color-close" onClick={this.handleClick} data-picker="title"><i className="linearicons-cross"></i></div>
                      </div>
                    : <div className="selected-color" data-picker="title" style={{width: "76px", height: "38px", backgroundColor: this.state.titleColor}} onClick={this.handleClick}></div>
                  }
                </div>
              </div>

              <div className="col-4">
                <div className="input-wrapper">
                  <label className="no-margin">Qual a cor da descrição?</label>
                  {
                    this.state.descriptionDisplayColorPicker ?
                      <div className="color-picker">
                        <SketchPicker color={ this.state.descriptionColor } onChange={ (color) => { this.handleColorChange(color, 'description') } } />
                        <div className="selected-color-close" onClick={this.handleClick} data-picker="description"><i className="linearicons-cross"></i></div>
                      </div>
                    : <div className="selected-color" data-picker="description" style={{width: "76px", height: "38px", backgroundColor: this.state.descriptionColor}} onClick={this.handleClick}></div>
                  }
                </div>
              </div>
            </div>
            
            <div className="row">
              <div className="col-4">
                <div className="input-wrapper">
                  <label>Qual a cor de fundo do CTA?</label>
                  {
                    this.state.btnBackgroundDisplayColorPicker ?
                      <div className="color-picker">
                        <SketchPicker color={ this.state.btnBackgroundColor } onChange={ (color) => { this.handleColorChange(color, 'btnBackground') } } />
                        <div className="selected-color-close" onClick={this.handleClick} data-picker="btnBackground"><i className="linearicons-cross"></i></div>
                      </div>
                    : <div className="selected-color" data-picker="btnBackground" style={{width: "76px", height: "38px", backgroundColor: this.state.btnBackgroundColor}} onClick={this.handleClick}></div>
                  }
                </div>
              </div>
              <div className="col-4">
                <div className="input-wrapper">
                  <label>Qual a cor do texto do CTA?</label>
                  {
                    this.state.btnColorDisplayColorPicker ?
                      <div className="color-picker">
                        <SketchPicker color={ this.state.btnColorColor } onChange={ (color) => { this.handleColorChange(color, 'btnColor') } } />
                        <div className="selected-color-close" onClick={this.handleClick} data-picker="btnColor"><i className="linearicons-cross"></i></div>
                      </div>
                    : <div className="selected-color" data-picker="btnColor" style={{width: "76px", height: "38px", backgroundColor: this.state.btnColorColor}} onClick={this.handleClick}></div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>

        <button type="button" className="btn btn-blue" style={{marginTop: "60px"}} onClick={this.handleSubmit}>Salvar</button>
      </div>
    )
  }
}

export { NotificationBoxProperties as NotificationBox }